import { graphql } from "gatsby";
import * as React from "react";
import styled from "styled-components";
import { useHubspotSubscribeForm } from "../../../hubspot";
import { Color } from "../../../constants/legacy";
import Modal from "../Modal";

type Props = {
  blogIndexPage: GatsbyTypes.SubscribePromptModalFragment | undefined;
  onDismiss: () => void;
};

export const query = graphql`
  fragment SubscribePromptModal on PrismicBlogIndexPageDataType {
    subscribe_modal_heading
    subscribe_modal_content
    subscribe_modal_first_button
    subscribe_modal_thanks_heading
    subscribe_modal_thanks_content
  }
`;

export default function SubscribePromptModal({
  blogIndexPage,
  onDismiss,
}: Props) {
  const hubspotSubscribe = useHubspotSubscribeForm();
  const [openedForm, setOpenedForm] = React.useState<boolean>(false);

  if (!blogIndexPage) return null;

  return (
    <Modal onDismiss={onDismiss} fadeInDuration={500}>
      {hubspotSubscribe.success ? (
        <>
          <h2>{blogIndexPage.subscribe_modal_thanks_heading}</h2>
          <p>{blogIndexPage.subscribe_modal_thanks_content}</p>
        </>
      ) : (
        <>
          <h2>{blogIndexPage.subscribe_modal_heading}</h2>
          <p>{blogIndexPage.subscribe_modal_content}</p>

          {openedForm ? (
            <StyledForm onSubmit={hubspotSubscribe.onSubmit}>
              <div style={{ flex: 1 }}>
                <StyledInput {...hubspotSubscribe.inputProps} />
              </div>
              <StyledButton type="submit">Subscribe</StyledButton>
            </StyledForm>
          ) : (
            <StyledButton onClick={() => setOpenedForm(true)}>
              {blogIndexPage.subscribe_modal_first_button}
            </StyledButton>
          )}
        </>
      )}
    </Modal>
  );
}

const StyledForm = styled.form`
  display: flex;
  align-items: center;
  margin: 0;
`;

const StyledInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  border: 1px #ccc solid;
  padding: 0 25px;

  @media (max-width: 400px) {
    padding: 0 10px;
  }
`;

const StyledButton = styled.button`
  box-sizing: border-box;
  height: 60px;
  border: 0;
  background-color: ${Color.darkBlue};
  color: ${Color.white};
  padding: 15px;
  cursor: pointer;
  transition: background-color 0.25s;

  &:hover {
    background-color: ${Color.blue};
  }
`;
